export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What are the three components of the CIA Triad?",
    "description": "Confidentiality (only authorized access), Integrity (no unauthorized modifications), Availability (information accessible when needed)"
  },
  {
    "id": 2,
    "topic_id": 4,
    "title": "What is a man-in-the-middle (MitM) attack?",
    "description": "An attacker intercepts communications between two parties, impersonates the system to each side, and relays information while secretly monitoring the conversation. Prevented with strong encryption."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "What is the difference between a replay attack and a MitM attack?",
    "description": "In a replay attack, the attacker captures legitimate authentication credentials and replays them later, rather than actively intercepting and relaying communications in real time."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What is non-repudiation?",
    "description": "Technical measures that prevent someone from denying that an action took place. Examples include digital signatures, biometrics, and video surveillance."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What is a denial-of-service (DoS) attack?",
    "description": "An attack that overwhelms a system with traffic to prevent legitimate users from accessing it. It targets the availability component of the CIA Triad."
  },
  {
    "id": 6,
    "topic_id": 3,
    "title": "What is the difference between identification and authentication?",
    "description": "Identification is simply claiming an identity (e.g., entering a username). Authentication is proving that identity with evidence (e.g., providing a password)."
  },
  {
    "id": 7,
    "topic_id": 3,
    "title": "What are the three authentication factors?",
    "description": "Something you know (password, PIN), something you are (biometrics like fingerprint or iris scan), and something you have (smart card, hardware token, authenticator app)."
  },
  {
    "id": 8,
    "topic_id": 3,
    "title": "Why is a password combined with a PIN not considered multifactor authentication (MFA)?",
    "description": "Both are “something you know.” MFA requires combining at least two different factor types (e.g., a password and a fingerprint)."
  },
  {
    "id": 9,
    "topic_id": 3,
    "title": "What is the purpose of accounting in the AAA framework?",
    "description": "Accounting tracks user activity by creating audit logs that can be used for investigation and reconstruction of events."
  },
  {
    "id": 10,
    "topic_id": 5,
    "title": "What is Personally Identifiable Information (PII)?",
    "description": "Any information that can be linked to a specific individual, such as name, Social Security number, email address, or biometric data."
  },
  {
    "id": 11,
    "topic_id": 5,
    "title": "What is the principle of data minimization?",
    "description": "Organizations should collect only the minimum personal information necessary for their stated purpose and discard it when it is no longer needed."
  },
  {
    "id": 12,
    "topic_id": 2,
    "title": "When must an organization provide a privacy notice?",
    "description": "At the time of data collection, when privacy policies change, and when new purposes for the data are introduced."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "In which three situations does a person NOT have a reasonable expectation of privacy?",
    "description": "When using employer-owned systems, when posting on social media, and when communicating in public spaces."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "What is the difference between a threat and a vulnerability?",
    "description": "A threat is an external or internal force that jeopardizes security (you cannot control it). A vulnerability is a weakness that a threat can exploit (you can control it). Risk exists only when both are present."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "What is the difference between qualitative and quantitative risk assessment?",
    "description": "Qualitative uses subjective judgments (low, medium, high). Quantitative uses objective numeric data and mathematical calculations."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "Define inherent risk, residual risk, and control risk.",
    "description": "Inherent risk is the initial level before any controls. Residual risk is what remains after security controls are applied. Control risk is new risk introduced by the controls themselves."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "What two factors determine the severity of a risk?",
    "description": "Likelihood (the probability a risk will occur) and impact (the amount of damage if it materializes)."
  },
  {
    "id": 18,
    "topic_id": 2,
    "title": "What is the difference between a security policy, a standard, and a procedure?",
    "description": "A policy is a high-level mandatory document describing expectations (technology-agnostic). A standard prescribes specific technical details of required controls. A procedure provides step-by-step instructions for performing a specific task."
  },
  {
    "id": 19,
    "topic_id": 2,
    "title": "What are the six core functions of the NIST Cybersecurity Framework (CSF) 2.0?",
    "description": "Govern, Identify, Protect, Detect, Respond, and Recover."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "What are the seven steps of the NIST Risk Management Framework (RMF)?",
    "description": "Prepare, Categorize, Select, Implement, Assess, Authorize, and Monitor."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "What is the difference between ISO 27001 and ISO 27002?",
    "description": "ISO 27001 establishes requirements for an information security management system (ISMS). ISO 27002 provides a detailed set of security controls for implementing ISO 27001."
  },
  {
    "id": 22,
    "topic_id": 1,
    "title": "What is defense in depth?",
    "description": "Applying multiple overlapping security controls to achieve the same objective, so that if one control fails, others remain in place to provide protection."
  },
  {
    "id": 23,
    "topic_id": 1,
    "title": "What is the difference between preventive, detective, and recovery controls?",
    "description": "Preventive controls stop issues from occurring (e.g., firewall). Detective controls identify breaches requiring investigation (e.g., IDS). Recovery controls remediate issues that have already occurred (e.g., restoring backups)."
  },
  {
    "id": 24,
    "topic_id": 1,
    "title": "What is the difference between technical, administrative, and physical controls?",
    "description": "Technical (logical) controls use technology (firewalls, encryption). Administrative controls use processes and procedures (training, access reviews). Physical controls affect the physical world (locks, cameras, guards)."
  },
  {
    "id": 25,
    "topic_id": 1,
    "title": "Give an example of a control that is both administrative and detective.",
    "description": "Log monitoring or periodic access reviews. Both are process-based (administrative) and identify issues after they occur (detective)."
  },
  {
    "id": 26,
    "topic_id": 1,
    "title": "What is the difference between due care and due diligence?",
    "description": "Due care means taking reasonable actions to protect the organization (implementing controls, training staff). Due diligence means ongoing monitoring and verification that those protections are actually working (audits, vulnerability scans, log reviews)."
  },
  {
    "id": 27,
    "topic_id": 1,
    "title": "What are the four canons of the ISC2 Code of Ethics, in order of priority?",
    "description": "I. Protect society, the common good, public trust, and infrastructure.\nII. Act honorably, honestly, justly, responsibly, and legally.\nIII. Provide diligent and competent service to principals.\nIV. Advance and protect the profession."
  },
  {
    "id": 28,
    "topic_id": 1,
    "title": "Who has standing to file an ethics complaint under each ISC2 canon?",
    "description": "Canons I and II: anyone. Canon III: only principals (employers/clients). Canon IV: any certified professional subscribing to an ethical code."
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "What must an ISC2 ethics complaint include?",
    "description": "A written, notarized affidavit containing the accused’s name, description of the violation, specific canons breached, the reason for standing, and corroborating evidence."
  },
  {
    "id": 30,
    "topic_id": 2,
    "title": "What are the three components of GRC?",
    "description": "Governance (policies, structures, and processes directing the organization), Risk Management (identifying, assessing, and responding to risks), and Compliance (adherence to laws, regulations, standards, and internal policies)."
  },
  {
    "id": 31,
    "topic_id": 2,
    "title": "What is a risk register?",
    "description": "A fundamental GRC document that records identified risks along with their likelihood, impact, response strategies, and current status."
  },
  {
    "id": 32,
    "topic_id": 2,
    "title": "What is risk appetite?",
    "description": "A governance-level decision determining how much risk leadership is willing to accept in pursuit of business opportunities."
  },
  {
    "id": 33,
    "topic_id": 2,
    "title": "What is the COBIT framework used for?",
    "description": "Governance and management of enterprise information technology. It aligns IT activities with business objectives."
  },
  {
    "id": 34,
    "topic_id": 2,
    "title": "What is the purpose of a Business Impact Analysis (BIA)?",
    "description": "To identify mission-essential functions, trace them back to the critical IT systems that support them, and produce a prioritized list of risks and potential impacts."
  },
  {
    "id": 35,
    "topic_id": 2,
    "title": "What is a Single Point of Failure (SPOF)?",
    "description": "Any component whose failure would cause an entire system or process to stop functioning. Addressed through redundancy (e.g., clustered servers, dual firewalls)."
  },
  {
    "id": 36,
    "topic_id": 2,
    "title": "What is the difference between high availability (HA) and fault tolerance (FT)?",
    "description": "HA uses multiple systems to protect against failure (e.g., server clusters). FT protects a single system from failing by building in resilient components (e.g., dual power supplies, RAID, NIC teaming)."
  },
  {
    "id": 37,
    "topic_id": 5,
    "title": "What is the difference between RAID 1 and RAID 5?",
    "description": "RAID 1 (mirroring) uses two identical disks that duplicate all data. RAID 5 (striping with parity) requires at least three disks and writes data with parity blocks across all disks. Note: RAID is fault tolerance, not backup."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "Define RTO, RPO, and RSL.",
    "description": "Recovery Time Objective (RTO): target time to restore a service. Recovery Point Objective (RPO): maximum acceptable data loss window. Recovery Service Level (RSL): percentage of service capacity required during a disaster."
  },
  {
    "id": 39,
    "topic_id": 2,
    "title": "What is the difference between full, differential, and incremental backups?",
    "description": "Full copies all data. Differential copies everything changed since the last full backup. Incremental copies only what changed since the most recent backup of any type (smallest backup, but longest restore)."
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "What is the difference between hot, warm, and cold disaster recovery sites?",
    "description": "Hot: fully operational, ready immediately (most expensive). Warm: hardware present but not running live, hours to days to activate. Cold: empty facility, weeks or months to activate (least expensive)."
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "List the five types of disaster recovery testing, from least to most disruptive.",
    "description": "Read-through (checklist review)\nWalk-through (tabletop exercise)\nSimulation (team discusses response to scenario)\nParallel test (activate DR alongside production)\nFull interruption test (shut down production, run from DR only)"
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "What is social engineering?",
    "description": "Using psychological manipulation to trick people into performing actions or divulging sensitive information. It exploits human psychology rather than technical vulnerabilities."
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "Name the six common social engineering tactics.",
    "description": "Authority/trust, intimidation, consensus/social proof, scarcity, urgency, and familiarity/liking."
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "What is the difference between phishing, spear phishing, whaling, vishing, and smishing?",
    "description": "Phishing: mass fraudulent emails. Spear phishing: targeted at specific individuals. Whaling: targets executives. Vishing: voice phishing by phone. Smishing: phishing via SMS text messages."
  },
  {
    "id": 45,
    "topic_id": 2,
    "title": "What is the difference between security training and security awareness?",
    "description": "Training provides detailed instruction requiring time and attention to learn new material. Awareness uses ongoing reminders (posters, videos, emails) to keep previously learned lessons top of mind."
  },
  {
    "id": 46,
    "topic_id": 2,
    "title": "What is the difference between a KPI and a KRI?",
    "description": "Key Performance Indicators (KPIs) are lagging, backward-looking measures of past performance (“How did we do?”). Key Risk Indicators (KRIs) are leading, forward-looking signals of increasing risk (“What might go wrong?”)."
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "Give two examples each of KPIs and KRIs.",
    "description": "KPIs: Mean Time to Detect (MTTD), patch compliance rate. KRIs: number of unpatched critical vulnerabilities on Internet-facing systems, percentage of employees who have not completed security training."
  },
  {
    "id": 48,
    "topic_id": 2,
    "title": "What is the difference between a dashboard, a scorecard, and a report?",
    "description": "Dashboards display real-time operational metrics visually. Scorecards periodically assess security posture against a defined framework using ratings. Reports provide detailed narrative analysis of metrics, incidents, and trends."
  },
  {
    "id": 49,
    "topic_id": 2,
    "title": "What is Return on Security Investment (RoSI)?",
    "description": "A metric used in scorecards that measures the financial return gained from security investments relative to their cost."
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "What are the four stages of the identity life cycle?",
    "description": "Roles definition, provisioning, review (recertification/attestation), and deprovisioning."
  },
  {
    "id": 51,
    "topic_id": 3,
    "title": "What is privilege creep and how does it occur?",
    "description": "The gradual accumulation of unnecessary access rights over time. It often occurs when access is provisioned by copying an existing user’s permissions rather than assigning from a defined role."
  },
  {
    "id": 52,
    "topic_id": 3,
    "title": "What is the difference between an orphaned account and a dormant account?",
    "description": "An orphaned account belongs to someone who has left the organization but whose account was never deprovisioned. A dormant account simply has not been used for an extended period. Both pose security risks."
  },
  {
    "id": 53,
    "topic_id": 3,
    "title": "What is privileged access management (PAM)?",
    "description": "A system that manages accounts with elevated privileges by storing credentials in a secure vault, automatically rotating passwords, and recording administrative sessions."
  },
  {
    "id": 54,
    "topic_id": 3,
    "title": "What is the Principle of Least Privilege (PoLP)?",
    "description": "Users should have only the minimum set of permissions necessary to perform their job duties, limiting both insider threat damage and the ability of external attackers to escalate access."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "What is Separation of Duties (SoD)?",
    "description": "No single person should possess two permissions that, combined, allow a sensitive operation. For example, one person creates vendor records while a different person approves payments."
  },
  {
    "id": 56,
    "topic_id": 3,
    "title": "What is the difference between MAC, DAC, and RBAC?",
    "description": "Mandatory access control (MAC): OS enforces access based on labels; users cannot modify. discretionary access control (DAC): resource owners control permissions using ACLs. Role-based access control (RBAC): permissions assigned to roles, users assigned to roles."
  },
  {
    "id": 57,
    "topic_id": 3,
    "title": "Which access control model is most commonly used and why?",
    "description": "DAC (discretionary access control) because it provides the flexibility most organizations need by allowing resource owners to manage their own permissions."
  },
  {
    "id": 58,
    "topic_id": 4,
    "title": "What are the seven layers of the OSI model, from bottom to top?",
    "description": "Physical, Data-Link, Network, Transport, Session, Presentation, Application."
  },
  {
    "id": 59,
    "topic_id": 4,
    "title": "What is the difference between TCP and UDP?",
    "description": "TCP is connection-oriented, reliable, tracks packets, and retransmits lost data. UDP is connectionless, faster, with lower overhead but no delivery guarantee. UDP is used for applications like streaming video."
  },
  {
    "id": 60,
    "topic_id": 4,
    "title": "What does an IP address starting with 169.254 indicate?",
    "description": "The system is using APIPA (Automatic Private IP Addressing), meaning it could not reach a DHCP server. This typically indicates a network connectivity problem."
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "List the four Wi-Fi encryption standards from weakest to strongest.",
    "description": "WEP (broken, never use), WPA with TKIP (vulnerable), WPA2 with AES/CCMP (secure, widely used), WPA3 with SAE (most secure)."
  },
  {
    "id": 62,
    "topic_id": 4,
    "title": "What is the difference between a site-to-site VPN and a remote access VPN?",
    "description": "Site-to-site VPNs securely connect two networks (e.g., branch offices). Remote access VPNs allow individual mobile workers to securely connect to the organization’s network."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "What is Zero Trust (ZT)?",
    "description": "A security philosophy of “never trust, always verify.” Every user, device, and network flow must be authenticated and authorized before access is granted, regardless of network location."
  },
  {
    "id": 64,
    "topic_id": 4,
    "title": "What is the three-zone firewall architecture?",
    "description": "Internet (untrusted external), DMZ/screened subnet (systems accepting public connections like web and mail servers), and intranet (trusted internal network). The DMZ sits between two firewall boundaries."
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "What is the difference between a VLAN and microsegmentation?",
    "description": "VLANs logically group systems at the switch level regardless of physical location. Microsegmentation creates much smaller, granular network segments with specific security policies per workload or application, aligning with Zero Trust (ZT)."
  },
  {
    "id": 66,
    "topic_id": 4,
    "title": "List five common network ports and their services.",
    "description": "DNS (53), HTTP (80), HTTPS (443), SSH (22), RDP (3389). Others include FTP (20/21) and SMTP (25/587)."
  },
  {
    "id": 67,
    "topic_id": 4,
    "title": "What are the five essential characteristics of cloud computing per NIST?",
    "description": "On-demand self-service, broad network access, resource pooling, rapid elasticity, and measured service."
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "What is the difference between IaaS, PaaS, and SaaS?",
    "description": "IaaS provides basic computing resources (servers, storage). PaaS provides a platform to run custom code. SaaS delivers a complete application to end users."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "What is the shared responsibility model in cloud computing?",
    "description": "Security responsibilities are divided between the cloud provider and the cloud customer. The provider secures the infrastructure; the customer secures their data, applications, and configurations. The exact split depends on the service model (IaaS, PaaS, or SaaS)."
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "What is multitenancy and what security concern does it raise?",
    "description": "Multiple customers share the same physical infrastructure in a public cloud. The primary concern is that a flaw in the isolation mechanisms could allow one tenant to access another tenant’s data."
  },
  {
    "id": 71,
    "topic_id": 5,
    "title": "What is the difference between symmetric and asymmetric encryption?",
    "description": "Symmetric uses the same key for encryption and decryption (faster, but key distribution is challenging). Asymmetric uses a key pair: a public key to encrypt and a private key to decrypt (slower, but solves key distribution)."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "How many symmetric keys are needed for 10 people to communicate securely with each other?",
    "description": "The formula is (n(n-1))/2, so (10(9))/2 = 45."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "What are the four properties of a cryptographic hash function?",
    "description": "It is one-way (cannot be reversed), produces a fixed-length output, produces a unique output for each unique input, and is repeatable (same input always produces the same hash)."
  },
  {
    "id": 74,
    "topic_id": 5,
    "title": "Which hash algorithms are considered broken, and which are still secure?",
    "description": "MD5 and SHA-1 are broken and should not be used. Some variations of SHA-2, and all SHA-3 are considered secure."
  },
  {
    "id": 75,
    "topic_id": 1,
    "title": "What is “harvest now, decrypt later” (HNDL)?",
    "description": "An attack strategy where adversaries capture encrypted data today with the intent of decrypting it in the future using quantum computers. This is why organizations are adopting post-quantum cryptography (PQC)."
  },
  {
    "id": 76,
    "topic_id": 5,
    "title": "What are the six stages of the data lifecycle?",
    "description": "Create, store, use, share, archive, and destroy."
  },
  {
    "id": 77,
    "topic_id": 5,
    "title": "What is the difference between clearing, purging, and destroying data?",
    "description": "Clearing overwrites data with zeros or random patterns. Purging uses advanced techniques (e.g., cryptographic erasure) that make recovery essentially impossible. Destroying physically demolishes the media (shredding, incineration)."
  },
  {
    "id": 78,
    "topic_id": 5,
    "title": "What is the difference between data anonymization and pseudonymization?",
    "description": "Anonymization permanently removes identifying information and cannot be reversed. Pseudonymization replaces identifiers with artificial ones using a mapping table, allowing re-identification if the mapping table is available."
  },
  {
    "id": 79,
    "topic_id": 5,
    "title": "What is data classification and why is it important?",
    "description": "Assigning a sensitivity label to data (e.g., Top Secret, Confidential, Internal, Public) so organizations can apply appropriate security controls based on the data’s value and sensitivity."
  },
  {
    "id": 80,
    "topic_id": 5,
    "title": "What is a SIEM and what are its two major functions?",
    "description": "A Security Information and Event Management system. It provides centralized log collection from across the organization and uses AI-driven correlation to detect patterns that may indicate malicious activity."
  },
  {
    "id": 81,
    "topic_id": 5,
    "title": "What does TTP stand for in threat intelligence?",
    "description": "Tactics, Techniques, and Procedures. These describe how threat actors operate: tactics are their high-level goals, techniques are how they achieve them, and procedures are the specific steps they follow."
  },
  {
    "id": 82,
    "topic_id": 5,
    "title": "What are the seven stages of the Cyber Kill Chain?",
    "description": "Reconnaissance, weaponization, delivery, exploitation, installation, command and control (C2), and actions on objectives."
  },
  {
    "id": 83,
    "topic_id": 5,
    "title": "Name three threat intelligence frameworks and describe each briefly.",
    "description": "MITRE ATT&CK (comprehensive matrix of adversary tactics and techniques), Cyber Kill Chain (seven-stage attack progression model), and Diamond Model (analyzes intrusions using four elements: adversary, capability, infrastructure, victim)."
  },
  {
    "id": 84,
    "topic_id": 5,
    "title": "What is an Indicator of Compromise (IoC)?",
    "description": "Observable evidence that a security breach may have occurred. Examples include known malicious IP addresses, suspicious file hashes, and unusual domain name lookups."
  },
  {
    "id": 85,
    "topic_id": 5,
    "title": "What are the four phases of NIST incident response?",
    "description": "Preparation; detection and analysis; containment, eradication, and recovery; and post-incident activity."
  },
  {
    "id": 86,
    "topic_id": 5,
    "title": "What is the first responder’s highest priority during an incident?",
    "description": "Assuming there is no imminent threat to human safety, the responder’s highest priority will be containing the damage by isolating affected systems to prevent the incident from spreading further."
  },
  {
    "id": 87,
    "topic_id": 2,
    "title": "What is the difference between a tabletop exercise and a simulation exercise?",
    "description": "A tabletop exercise is discussion-based, where the team talks through a scenario. A simulation exercise involves active, real-time response actions, testing operational procedures under more realistic conditions."
  },
  {
    "id": 88,
    "topic_id": 5,
    "title": "Who should be represented on an incident response team?",
    "description": "Management, information security, physical security, technical subject matter experts, legal counsel, public relations/communications, and human resources."
  },
  {
    "id": 89,
    "topic_id": 5,
    "title": "What are the six stages of asset lifecycle management?",
    "description": "Planning & procurement, deployment & configuration, operation & maintenance, monitoring & assessment, end of life, and disposal/decommissioning."
  },
  {
    "id": 90,
    "topic_id": 5,
    "title": "What is the difference between End of Life (EOL) and End of Support (EOS)?",
    "description": "EOL means the vendor has stopped selling and actively developing the product. EOS means the vendor has stopped providing security patches and technical support. EOS poses the greater security risk."
  },
  {
    "id": 91,
    "topic_id": 5,
    "title": "What is a security baseline in configuration management?",
    "description": "A documented, approved configuration snapshot of a system that represents a secure state. It serves as a reference point to detect unauthorized changes and enforce consistent security settings."
  },
  {
    "id": 92,
    "topic_id": 2,
    "title": "What are the six steps of the change management process?",
    "description": "Request, evaluation/impact assessment, approval, implementation, documentation, and rollback (if needed). Significant changes are reviewed by a change advisory board (CAB)."
  },
  {
    "id": 93,
    "topic_id": 5,
    "title": "What is the difference between red team, blue team, and purple team exercises?",
    "description": "Red team simulates attackers. Blue team defends against attacks. Purple team combines both, with attackers and defenders collaborating to improve security together."
  },
  {
    "id": 94,
    "topic_id": 5,
    "title": "What is the difference between an authenticated and an unauthenticated vulnerability scan?",
    "description": "Authenticated scans use valid credentials to log into systems and examine them from inside, finding more vulnerabilities. Unauthenticated scans test from the outside without credentials, simulating an external attacker’s view."
  },
  {
    "id": 95,
    "topic_id": 5,
    "title": "What is the difference between static analysis and dynamic analysis?",
    "description": "Static analysis examines source code without running it, looking for vulnerabilities in the code itself. Dynamic analysis tests a running application by interacting with it and observing its behavior."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "What is the STRIDE threat model?",
    "description": "A framework for categorizing threats: Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, and Elevation of Privilege."
  },
  {
    "id": 97,
    "topic_id": 1,
    "title": "What is the difference between integrity and non-repudiation?",
    "description": "Integrity ensures data has not been altered without authorization. Non-repudiation goes further by proving who performed an action and preventing them from denying it."
  },
  {
    "id": 98,
    "topic_id": 2,
    "title": "What is the difference between a regulation and a standard?",
    "description": "A regulation is a mandatory requirement imposed by government that carries the force of law. A standard is a set of detailed technical requirements, often voluntary (e.g., ISO, CIS), though some become mandatory when referenced by regulations or policy."
  },
  {
    "id": 99,
    "topic_id": 5,
    "title": "What is cryptographic erasure?",
    "description": "A data sanitization technique where encrypted data is rendered unrecoverable by destroying the encryption key rather than the data itself. It is fast and effective for cloud and SSD environments where traditional overwriting is not feasible or leaves remnants."
  },
  {
    "id": 100,
    "topic_id": 5,
    "title": "What is the Diamond Model of Intrusion Analysis?",
    "description": "A threat intelligence framework that analyzes security incidents using four core elements: adversary (who), capability (how), infrastructure (what tools/systems), and victim (the target). It helps analysts understand relationships between these elements across multiple incidents."
  },
  {
    "id": 101,
    "topic_id": 1,
    "title": "What is the difference between artificial intelligence (AI) and machine learning (ML)?",
    "description": "AI is a broad term for computer systems that can perform tasks normally requiring human intelligence, such as recognizing patterns, making decisions, and generating content. ML is a subset of AI in which systems learn from data rather than following explicitly programmed rules."
  },
  {
    "id": 102,
    "topic_id": 4,
    "title": "What is a large language model (LLM)?",
    "description": "A type of AI system trained on massive amounts of text data that can generate human-like text, answer questions, summarize documents, and write code."
  },
  {
    "id": 103,
    "topic_id": 5,
    "title": "What is the difference between training and inference in machine learning?",
    "description": "Training is the process by which a model analyzes large amounts of data and adjusts its internal parameters to produce accurate results. Inference is the use of the trained model in production to analyze new inputs it has not seen before."
  },
  {
    "id": 104,
    "topic_id": 1,
    "title": "What is hallucination in the context of AI?",
    "description": "When a large language model generates output that sounds plausible but is factually incorrect. LLMs predict the most likely next word in a sequence rather than retrieving verified facts, so they can fabricate information, cite nonexistent sources, or present outdated data with high confidence."
  },
  {
    "id": 105,
    "topic_id": 5,
    "title": "What is model poisoning?",
    "description": "An attack in which an adversary tampers with the data used to train a machine learning model. Because the model learns its behavior from its training data, corrupted training data can cause dangerously inaccurate results, such as a poisoned spam filter that lets phishing emails through."
  },
  {
    "id": 106,
    "topic_id": 1,
    "title": "What is algorithmic bias?",
    "description": "When an AI system produces unfair or discriminatory results due to flaws in its training data or design. Organizations should guard against algorithmic bias by prioritizing transparency in how their AI systems make decisions."
  },
  {
    "id": 107,
    "topic_id": 1,
    "title": "What AI-specific threats should organizations include in their risk assessments?",
    "description": "Model poisoning, prompt injection, data leakage, denial of service (DoS), and the potential for unexpected behavior."
  },
  {
    "id": 108,
    "topic_id": 5,
    "title": "What is model drift?",
    "description": "A gradual decline in an AI system’s performance over time, caused when the data it encounters in production diverges from the data it was trained on. Organizations should monitor for drift and establish thresholds that trigger review or retraining."
  },
  {
    "id": 109,
    "topic_id": 2,
    "title": "What should AI backup procedures cover?",
    "description": "Model files, training datasets, and configuration parameters. Without these, an AI system may need to be retrained from scratch if its underlying data is lost or corrupted."
  },
  {
    "id": 110,
    "topic_id": 3,
    "title": "How should organizations manage AI service accounts?",
    "description": "Through a formal lifecycle from provisioning to deprovisioning, applying the principle of least privilege, conducting periodic access reviews, and promptly disabling accounts when an AI tool is retired or replaced."
  },
  {
    "id": 111,
    "topic_id": 3,
    "title": "What is impossible travel?",
    "description": "An authentication anomaly in which a user appears to log in from two distant locations within an unrealistically short time frame, such as New York and Tokyo fifteen minutes apart. AI-driven authentication systems can flag this pattern and require additional verification."
  },
  {
    "id": 112,
    "topic_id": 4,
    "title": "How do AI-powered firewalls and intrusion detection systems differ from traditional ones?",
    "description": "Traditional systems rely on known signatures, while AI-powered systems use machine learning to identify novel threats by recognizing patterns that deviate from a learned baseline of normal network behavior."
  },
  {
    "id": 113,
    "topic_id": 4,
    "title": "Why is network segmentation important for AI environments?",
    "description": "It isolates AI development environments from sensitive production data, limiting damage if one environment is compromised. This supports Zero Trust (ZT) principles and protects high-value training data from lateral movement by attackers."
  },
  {
    "id": 114,
    "topic_id": 5,
    "title": "What is alert fatigue, and how does AI help address it?",
    "description": "Alert fatigue is the overwhelming volume of security notifications that can cause analysts to miss genuine threats. AI-driven SIEM correlation helps distinguish routine events from high-priority incidents that require human intervention."
  },
  {
    "id": 115,
    "topic_id": 5,
    "title": "What is the data leakage risk associated with public AI tools?",
    "description": "When employees interact with public AI services, they may inadvertently share sensitive organizational information such as source code, customer data, internal documents, or proprietary strategies. Once submitted, the organization loses control over how that data is stored, used, or retained, and it may even be incorporated into future model training."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "What are the three key goals of information security represented by the CIA triad?",
    "description": "The CIA triad references the three key goals of information security: confidentiality, integrity, and availability."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "What are the major threats to confidentiality?",
    "description": "Confidentiality protects sensitive information from unauthorized access. The major threats to confidentiality include social engineering, phishing, shoulder surfing, snooping, device theft, dumpster diving, eavesdropping, wiretapping, and pretexting."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "What are the major threats to integrity in information security?",
    "description": "Integrity protects information and systems from unauthorized modification or destruction. The major threats to integrity include data modification, impersonation, man-in-the-middle, and replay attacks."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "What are the major threats to availability in information security?",
    "description": "Availability ensures that authorized users have access to information when they need it. The major threats to availability include denial-of-service attacks, power outages, hardware failures, equipment destruction, and service outages."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "What technical security principle ensures a user cannot deny taking an action?",
    "description": "Non-repudiation uses technical measures to ensure that a user cannot later deny taking an action."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "What are the three major steps of the access control process?",
    "description": "The access control process consists of three major steps. Identification is when a user asserts their identity. Authentication is the process by which a user proves their identity. Authorization is the process by which the system determines whether a user is allowed to perform a requested action."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "What is the purpose of accounting processes in security incident investigation?",
    "description": "Accounting processes create a record of who performed which actions on a system and are useful when investigating security incidents."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "What are the three authentication factors that MFA combines?",
    "description": "Multi-factor authentication (MFA) combines at least two of the three factors: something you know, something you have, and something you are."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "What is the difference between password length requirements and password complexity requirements?",
    "description": "Password length requirements set a minimum number of characters a user’s password must contain, whereas password complexity requirements mandate the use of different character types."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "What is the difference between password history and password expiration requirements?",
    "description": "Password history requirements prevent the reuse of old passwords, whereas password expiration requirements require periodic password changes. Users should be permitted to reset their passwords whenever they wish."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Why should users avoid reusing passwords across multiple sites, and what tool can help manage unique passwords?",
    "description": "Users should be discouraged from reusing passwords across multiple sites, as this increases the risk of compromise. Password managers provide a convenient way to manage many unique, strong passwords."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "What obligation do IT professionals have regarding personal information and privacy expectations?",
    "description": "IT professionals have an obligation to protect the privacy of personal information, particularly when the individuals involved have a reasonable expectation of privacy."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "What types of personal information must be safeguarded in security practices?",
    "description": "The types of personal information that must be safeguarded include personally identifiable information (PII), which is any personal information that may be tied to an individual, and protected health information (PHI), which includes medical records."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "What are the nine components of the Privacy Management Framework?",
    "description": "The nine Privacy Management Framework (PMF) components are as follows: Management; Agreement, notice, and communication; Collection and creation; Use, retention, and disposal; Access; Disclosure to third parties; Security for privacy; Data integrity and quality; Monitoring and enforcement."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "What are the three main categories of risk based on their origin or scope?",
    "description": "Internal risks are those that arise from within the organization. External risks are those that originate outside the organization. Multiparty risks are shared among many different organizations."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "What is the relationship between threats, vulnerabilities, and risk?",
    "description": "Threats are internal or external forces that jeopardize the security of your information and systems. Vulnerabilities are weaknesses in assets that threats can exploit to undermine the confidentiality, integrity, or availability of your information or systems. Risks occur when your environment contains both a vulnerability and a threat that could exploit it."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "What two factors are used to prioritize risks in risk management?",
    "description": "Risks are prioritized based on their likelihood and impact. The likelihood of a risk is the probability that it will actually occur. The impact of a risk is the amount of damage that will occur if the risk materializes."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "What is the key difference between qualitative and quantitative risk assessment techniques?",
    "description": "Qualitative risk assessment techniques use subjective judgments to assess risks, typically categorizing them as low, medium, or high on both the likelihood and impact scales. Quantitative risk assessment techniques use objective numeric ratings to assess the likelihood and impact of a risk."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "What are the four primary risk treatment options in risk management?",
    "description": "The four risk treatment options are avoiding, transferring, mitigating, and accepting a risk."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "What is the relationship between inherent risk, controls, residual risk, and control risk?",
    "description": "An organization’s risk profile begins with its inherent risk. Security professionals then apply controls to reduce the inherent risk, leaving a residual risk. Controls may introduce new control risks."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "What laws and regulations must security professionals understand at international, national, state, and local levels?",
    "description": "Security professionals must be aware of all the laws and regulations that apply to their organizations, including international, national, state, and local. Important examples include the European Union’s General Data Protection Regulation (GDPR), the Health Insurance Portability and Accountability Act (HIPAA), the Gramm-Leach-Bliley Act (GLBA), and the Payment Card Industry Data Security Standard (PCI DSS)."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "What are the primary NIST frameworks used for managing security and privacy programs?",
    "description": "Cybersecurity frameworks provide structured approaches to managing security and privacy programs. Key frameworks include the NIST Cybersecurity Framework (CSF) and the NIST Risk Management Framework (RMF)."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "What is the relationship between guidelines and frameworks in security control implementation?",
    "description": "Guidelines are more specific recommendations that advise organizations on best practices for implementing security controls. While frameworks describe what an organization should address, guidelines often describe how to approach those activities."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "What are the common types of security governance documents that organizations must comply with?",
    "description": "The common types of security governance documents include policies, standards, and procedures. Compliance with policies, standards, and procedures is mandatory. Organizations may also adopt external standards such as ISO 27001/27002 and CIS Controls/Benchmarks."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "How are security controls classified?",
    "description": "Security controls can be classified by purpose and mechanism of action."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "What are the three main types of security controls and their primary functions?",
    "description": "The purpose types are preventive, detective, and corrective. Preventive controls are designed to stop a security issue from occurring in the first place. Detective controls identify potential security breaches that require further investigation. Corrective controls remediate security issues that have already occurred. If ransomware infects a system and wipes out critical information, restoring that information from backup is an example of a corrective control."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "What are the three main categories of security control mechanisms of action?",
    "description": "The mechanism of action categories are technical, administrative, and physical. Technical controls use technology to achieve security objectives. Administrative controls are the policies and processes you put in place to manage technology securely. Physical controls are those that impact the physical world."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "What does the first canon of the ISC2 Code of Ethics require you to protect?",
    "description": "The first canon of the ISC2 Code of Ethics says that you must protect society, the common good, necessary public trust and confidence, and the infrastructure. Anyone may file a complaint against a member under the first canon."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "What does the second canon of the ISC2 Code of Ethics require, and who can file complaints under it?",
    "description": "The second canon of the ISC2 Code of Ethics says that you must act honorably, honestly, justly, responsibly, and legally. Anyone may file a complaint against a member under the second canon."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Which principal can file a complaint against a member under the third canon of the ISC2 Code of Ethics?",
    "description": "The third canon of the ISC2 Code of Ethics says that you must provide diligent and competent service to principals. Only one of those principals (an individual’s employer or consulting client) may file a complaint against a member under the third canon."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "What does the fourth canon of the ISC2 Code of Ethics require, and who may file complaints under it?",
    "description": "The fourth canon of the ISC2 Code of Ethics says that you must advance and protect the profession. Any certified professional who subscribes to an ethical code may file a complaint against a member under the fourth canon."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "What is the relationship between due care and due diligence in security management?",
    "description": "Due care is the responsibility to take reasonable actions to protect the organization, such as implementing security policies and deploying controls. Due diligence is the ongoing effort to investigate, monitor, and verify that those protections are working effectively. Both concepts work together to demonstrate responsible security management."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "What is the ISC2 Code of Professional Conduct and who is it intended for?",
    "description": "The ISC2 Code of Professional Conduct provides a global framework for ethical and professional behavior in cybersecurity. It is organized around two guiding principles: ethics and professional conduct. It covers topics including integrity, confidentiality, respect for laws, public safety, responsibility and accountability, collaboration, competence, and reporting issues. Unlike the Code of Ethics, it is intended for all cybersecurity professionals, not just ISC2 members."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "What is the integrated approach that combines governance, risk management, and compliance into a coordinated strategy?",
    "description": "Understand the purpose of governance, risk, and compliance (GRC). GRC is an integrated approach that combines governance, risk management, and compliance into a coordinated strategy. Governance provides the policies and structures for decision-making, risk management identifies and responds to potential threats, and compliance ensures adherence to laws, regulations, and internal policies."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "What are the key benefits and importance of implementing a GRC program in an organization?",
    "description": "Know why GRC is important to organizations. GRC programs align security activities with business objectives, help organizations meet regulatory requirements, improve operational efficiency by eliminating silos, build stakeholder confidence, and enable continuous improvement of security programs."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "What are the key GRC frameworks and tools used in governance, risk, and compliance?",
    "description": "Be familiar with GRC frameworks and tools. Key GRC frameworks include COBIT for IT governance, ISO 31000 for risk management, and ISO 27001 for information security management systems. The NIST Cybersecurity Framework (CSF) and Risk Management Framework (RMF) also support GRC activities. Core GRC tools include risk registers, compliance tracking systems, policy management tools, and audit management systems."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "What is the primary purpose of a business impact analysis in business continuity planning?",
    "description": "Business continuity efforts are activities designed to keep a business running in the face of adversity. The business impact analysis (BIA) is an impact assessment that begins by identifying the organization’s mission-essential functions and then tracing those backward to identify the critical IT systems that support those processes."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "What does a single point of failure analysis identify in a system?",
    "description": "Single point of failure analyses identify places where the failure of one component could cause an entire system or service to become unavailable."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "What is the key difference between high availability and fault tolerance?",
    "description": "High availability (HA) uses multiple systems to protect against failures. Fault tolerance (FT) helps to protect a single system from failing in the first place by making it resilient in the face of technical failures."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Which three components are most likely to fail in a computer system?",
    "description": "Three of the components most likely to fail in a computer system are the power supply, storage, and network connection."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "What is the primary purpose of disaster recovery within business continuity?",
    "description": "Disaster recovery (DR) is a subset of business continuity activities designed to restore a business to normal operations as quickly as possible following a disruption."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "What are the definitions of RTO, RPO, and RSL in disaster recovery planning?",
    "description": "The recovery time objective (RTO) is the target time to restore a service to operation following a disruption. The recovery point objective (RPO) is the maximum time window during which data may be lost due to a disaster. The recovery service level (RSL) is the percentage of a service that must be available during a disaster."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "What are the key differences between full, differential, and incremental backups?",
    "description": "Full backups include everything on the media being backed up. They make a complete copy of the data. Snapshots are a form of full backup created using specialized hardware functionality. Differential backups supplement full backups and create a copy of only the data that has changed since the last full backup. Incremental backups include only those files that have changed since the most recent full or incremental backup."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "What are the key differences between hot, warm, and cold disaster recovery sites?",
    "description": "Hot sites are fully operational data centers with all the equipment and data required to run operations, ready to go. Cold sites are facilities that can be used to restore operations eventually, but they are essentially empty data centers. Warm sites have the hardware and software necessary to support the company’s operations, but they are not kept running in parallel."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "What are the five levels of disaster recovery testing, from least to most disruptive?",
    "description": "Disaster recovery tests range from least to most disruptive. Read-throughs ask team members to review the plan on their own, and walk-throughs gather the team to discuss it. Simulations have the team carry out part of the response to a scenario, parallel tests activate the recovery environment while the primary site keeps running, and full interruption tests shut down the primary site to run from the recovery environment."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "What role does organizational culture play in establishing an effective cybersecurity program?",
    "description": "Organizational culture is a critical foundation for cybersecurity. A strong security culture starts with leadership setting the tone at the top and treating security as a core organizational value. When security is embedded in the culture, employees naturally consider security implications in their daily work and take ownership of their role in protecting the organization."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "What are the main psychological strategies that social engineers use to exploit human behavior?",
    "description": "The main strategies that social engineers leverage—authority and trust, intimidation, consensus and social proof, scarcity, urgency, and familiarity—exploit human psychology to circumvent security controls. Training programs should emphasize the nature of these tactics, teaching employees to recognize and respond appropriately to potential social engineering attempts."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "What role do security training programs play in an organization's cybersecurity defense strategy?",
    "description": "Security training programs serve as the frontline defense in cybersecurity, empowering employees to recognize and prevent security incidents. Training efforts must continuously adapt to the evolving landscape of cyber threats, ensuring that employees remain informed about current risks and effective mitigation strategies."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "What is phishing and what are its main variations?",
    "description": "Phishing is one of the most common social engineering attacks. Phishing uses fraudulent messages to trick staff members into revealing sensitive information or clicking malicious links. Variations include spear phishing (targeted), whaling (executives), vishing (voice), and smishing (SMS). Defense requires both technical controls and user education."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "What are examples of lagging indicators used to measure past security performance?",
    "description": "Key performance indicators (KPIs) are lagging indicators that measure past security performance, such as mean time to detect, mean time to respond, and patch compliance rates."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "What are key risk indicators and what do they measure in an organization?",
    "description": "Key risk indicators (KRIs) are leading indicators that signal increasing risk exposure before incidents occur, such as the number of unpatched critical vulnerabilities or the percentage of employees who have not completed security training."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "What are the key differences between dashboards, scorecards, and reports in security monitoring?",
    "description": "Dashboards provide real-time visual displays of security metrics for continuous monitoring. Scorecards provide periodic assessments of security posture against frameworks or goals, often using simple rating systems such as color codes. Reports deliver detailed narrative analysis, context, and recommendations tailored to specific audiences."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "What characteristics should effective security metrics possess, and how should organizations select and present them?",
    "description": "Effective metrics are clearly defined, repeatable, and actionable. Organizations should select a balanced mix of KPIs and KRIs that align with business objectives, and tailor the presentation of results to the needs of different audiences, from technical security teams to executive leadership."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "What are the four main phases of the identity life cycle?",
    "description": "The identity life cycle consists of roles definition, provisioning, review, and deprovisioning. Role definitions establish the access patterns for each job function. Provisioning creates accounts and grants appropriate access. Review verifies that access remains appropriate over time. Deprovisioning removes access when it is no longer needed, such as when an employee leaves the organization."
  },
  {
    "id": 170,
    "topic_id": 200,
    "title": "What security risks arise from failing to promptly remove employee access, and how can organizations mitigate them?",
    "description": "Accounts that are not promptly deprovisioned when an employee departs create significant security vulnerabilities. Regular access reviews, also called access recertifications, help organizations identify excessive privileges, orphaned accounts, and dormant accounts. Both processes are essential for maintaining the principle of least privilege."
  },
  {
    "id": 171,
    "topic_id": 200,
    "title": "What standards and tools are used for identity management and access control?",
    "description": "NIST SP 800-63 provides guidance on digital identity, while ISO/IEC 24760 defines an identity management framework. Key tools include directory services such as Active Directory (AD), identity and access management (IAM) platforms that automate provisioning and deprovisioning, and privileged access management (PAM) tools for securing high-privilege accounts."
  },
  {
    "id": 172,
    "topic_id": 200,
    "title": "What does the principle of least privilege require users to have?",
    "description": "The principle of least privilege states that users should have only the minimum set of privileges necessary to perform their job responsibilities."
  },
  {
    "id": 173,
    "topic_id": 200,
    "title": "What does the separation of duties principle prevent any single person from possessing?",
    "description": "The separation of duties principle says that no single person should possess two permissions that, in combination, allow them to perform a sensitive operation."
  },
  {
    "id": 174,
    "topic_id": 200,
    "title": "What type of access control system has the operating system itself restrict permissions on resources?",
    "description": "Mandatory access control (MAC) systems are the most stringent type of access control. In MAC systems, the operating system itself restricts the permissions that may be granted to users and processes on system resources."
  },
  {
    "id": 175,
    "topic_id": 200,
    "title": "What access control model allows resource owners to assign permissions to other users at their discretion?",
    "description": "Discretionary access control (DAC) systems allow users to assign access permissions to other users—the owners of files, computers, and other resources have the discretion to configure permissions as they see fit."
  },
  {
    "id": 176,
    "topic_id": 200,
    "title": "How do administrators assign permissions to users in role-based access control systems?",
    "description": "In role-based access control (RBAC) systems, administrators assign users to roles based upon their job responsibilities and assign the permissions necessary to carry out different jobs to those roles."
  },
  {
    "id": 177,
    "topic_id": 200,
    "title": "What are the seven layers of the OSI model in order?",
    "description": "The Open Systems Interconnection (OSI) model describes network communications using seven layers. They are, in order, the Physical layer, Data-Link layer, Network layer, Transport layer, Session layer, Presentation layer, and Application layer."
  },
  {
    "id": 178,
    "topic_id": 200,
    "title": "What protocols does the TCP/IP suite use at the Network and Transport layers?",
    "description": "Modern networking uses a suite of protocols called TCP/IP. This suite uses the IP protocol for routing information over networks at the Network layer. Each communication also uses a Transport layer protocol, typically TCP or UDP."
  },
  {
    "id": 179,
    "topic_id": 200,
    "title": "How do IPv4 and IPv6 addresses differ in their notation and format?",
    "description": "A system’s IP address uniquely identifies it on a network. IPv4 addresses use the dotted quad notation of four integers ranging from 0 to 255, separated by periods. IPv6 addresses use eight groups of four hexadecimal digits separated by colons."
  },
  {
    "id": 180,
    "topic_id": 200,
    "title": "What authentication technologies and encryption standards should Wi-Fi networks implement?",
    "description": "Wi-Fi networks use a variety of authentication technologies, including pre-shared keys (PSKs), enterprise authentication, and captive portals. In addition, Wi-Fi networks should use either WPA2 or WPA3 encryption to provide secure communications."
  },
  {
    "id": 181,
    "topic_id": 200,
    "title": "What are the two main types of VPNs and how do they differ in their connectivity approach?",
    "description": "VPNs provide secure connectivity by creating encrypted tunnels over the Internet. Site-to-site VPNs connect remote networks to each other, while remote access VPNs allow individual users to securely connect to an organization’s network from remote locations."
  },
  {
    "id": 182,
    "topic_id": 200,
    "title": "What types of systems are included in industrial control systems (ICS) environments?",
    "description": "Embedded systems, including industrial control systems (ICS), present unique security challenges. ICS environments include supervisory control and data acquisition (SCADA) systems, distributed control systems, and programmable logic controllers."
  },
  {
    "id": 183,
    "topic_id": 200,
    "title": "What is a critical control for protecting ICS and IoT devices from their inherent vulnerabilities?",
    "description": "ICS and IoT devices face challenges, including difficulty applying patches, shared network access, and cloud-based command-and-control. Network segmentation is a critical control for protecting embedded systems."
  },
  {
    "id": 184,
    "topic_id": 200,
    "title": "What security strategy uses multiple layers of controls to protect assets?",
    "description": "Defense in depth is a security strategy that uses multiple layers of controls to protect assets. By implementing physical, perimeter, network, endpoint, application, data, and administrative controls, organizations ensure that the failure of any single control does not compromise the entire system."
  },
  {
    "id": 185,
    "topic_id": 200,
    "title": "What security philosophy requires authentication and authorization for every access request and implements continuous verification?",
    "description": "Zero Trust (ZT) is a security philosophy based on the principle of “never trust, always verify.” Zero Trust architectures require authentication and authorization for every access request, use least privilege access, implement microsegmentation, and continuously monitor for threats."
  },
  {
    "id": 186,
    "topic_id": 200,
    "title": "How do firewalls control network traffic between security zones in a typical three-zone architecture?",
    "description": "Firewalls control network traffic between security zones by applying security rules. Organizations typically use a three-zone architecture with Internet, intranet, and demilitarized zone (DMZ) segments. Firewall rules use ports and application information to make access control decisions."
  },
  {
    "id": 187,
    "topic_id": 200,
    "title": "What are the key differences between VLANs and microsegmentation in network segmentation?",
    "description": "Network segmentation divides networks into smaller, isolated zones using technologies including VLANs and microsegmentation. VLANs logically group related systems regardless of physical location, while microsegmentation provides finer-grained isolation at the workload level."
  },
  {
    "id": 188,
    "topic_id": 200,
    "title": "What are the four cloud deployment models and their key characteristics?",
    "description": "Cloud customers can choose from four deployment models. Public cloud offerings use shared hardware for many customers in a multitenant approach. Private cloud offerings dedicate hardware to a single customer. Community cloud offerings are open only to members of a specific community. Hybrid cloud offerings mix resources from two or more deployment models."
  },
  {
    "id": 189,
    "topic_id": 200,
    "title": "What are the three major categories of cloud services?",
    "description": "Cloud services come in three major categories: software as a service (SaaS), platform as a service (PaaS), and infrastructure as a service (IaaS)."
  },
  {
    "id": 190,
    "topic_id": 200,
    "title": "What are the five NIST essential characteristics of cloud computing?",
    "description": "Know the five essential characteristics of cloud computing. The five NIST essential characteristics are on-demand self-service, broad network access, resource pooling, rapid elasticity, and measured service. These characteristics define what makes a service a true cloud computing offering."
  },
  {
    "id": 191,
    "topic_id": 200,
    "title": "How do security responsibilities differ between IaaS and SaaS cloud service models?",
    "description": "Understand the shared security model for cloud computing. In a cloud environment, the cloud provider and the customer share responsibility for security. The division of responsibilities depends on the service model. In IaaS, the customer manages more security responsibilities, while in SaaS, the provider manages most security tasks."
  },
  {
    "id": 192,
    "topic_id": 200,
    "title": "What is the relationship between encryption, decryption, plaintext, and ciphertext?",
    "description": "Encryption is the process of transforming plaintext into ciphertext that unauthorized individuals can’t read. Decryption uses a decryption key to convert the ciphertext back into plaintext."
  },
  {
    "id": 193,
    "topic_id": 200,
    "title": "What are the two main approaches to encrypting data at rest on a device?",
    "description": "Encryption can protect data at rest by encrypting individual files or folders. Full-disk encryption (FDE) protects the entire contents of a device by encrypting it."
  },
  {
    "id": 194,
    "topic_id": 200,
    "title": "What methods can protect data in transit across networks?",
    "description": "Encryption can be used to protect data in transit by encrypting it as it travels over a network. The HTTPS protocol encrypts web traffic and is a secure alternative to the unencrypted HTTP protocol. Virtual private networks (VPNs) encrypt entire network connections."
  },
  {
    "id": 195,
    "topic_id": 200,
    "title": "What is the key difference between symmetric and asymmetric encryption algorithms?",
    "description": "Symmetric encryption algorithms, such as AES, use the same key for both encryption and decryption. Asymmetric encryption algorithms, such as RSA, use public-private key pairs."
  },
  {
    "id": 196,
    "topic_id": 200,
    "title": "What is a hash function and what are its key characteristics?",
    "description": "Hash functions are one-way functions that transform a variable-length input into a unique, fixed-length output."
  },
  {
    "id": 197,
    "topic_id": 200,
    "title": "What threat does quantum computing pose to current public-key encryption, and how does the harvest now, decrypt later attack exploit this?",
    "description": "Quantum computing poses a future threat to public-key encryption algorithms like RSA and ECC. In the harvest now, decrypt later (HNDL) attack strategy, adversaries collect encrypted data today, intending to decrypt it with future quantum computers. Post-quantum cryptography (PQC) standards address this threat."
  },
  {
    "id": 198,
    "topic_id": 200,
    "title": "What are the key stages of data management throughout its complete life cycle?",
    "description": "Data must be appropriately managed throughout its life cycle—from creation to destruction. This includes securely creating, storing, using, sharing, archiving, and ultimately destroying data when it’s no longer necessary. The destruction method should be secure and adhere to standards such as the NIST guidelines for media sanitization."
  },
  {
    "id": 199,
    "topic_id": 200,
    "title": "What are the purposes and common classification levels used in data classification?",
    "description": "Data classification is crucial for implementing appropriate security measures. Information should be categorized based on its sensitivity and criticality to the organization. Common classification levels include U.S. federal government levels like Top Secret, Secret, and Confidential, and business-friendly terms such as Highly Sensitive, Sensitive, Internal, and Public. These levels determine the appropriate storage, handling, access, and protection requirements for information."
  },
  {
    "id": 200,
    "topic_id": 200,
    "title": "Why should an organization standardize the labeling of classified information?",
    "description": "Labeling of classified information should be standardized within an organization. This practice ensures that users can consistently recognize sensitive information and handle it correctly, thereby mitigating the risk of accidental data leaks or breaches."
  },
  {
    "id": 201,
    "topic_id": 200,
    "title": "What are the key differences between data masking, tokenization, anonymization, and pseudonymization?",
    "description": "Data masking protects sensitive information by replacing it with realistic but fictitious values. Static masking creates permanent masked copies, dynamic masking applies rules in real time based on user permissions, and tokenization replaces sensitive values with meaningless tokens. Anonymization permanently removes identifying information, while pseudonymization replaces it with artificial identifiers that can be reversed."
  },
  {
    "id": 202,
    "topic_id": 200,
    "title": "What role do logs and SIEM systems play in detecting security events and maintaining accountability?",
    "description": "Logs provide crucial insights into security events by enabling accountability, traceability, and auditability. Security information and event management (SIEM) systems centralize log collection and use correlation to detect patterns of malicious activity across an organization."
  },
  {
    "id": 203,
    "topic_id": 200,
    "title": "What is security event triage and what factors do analysts consider when prioritizing alerts?",
    "description": "Security event triage is the process of classifying, validating, and prioritizing security alerts. Analysts consider event severity, asset criticality, and potential business impact when determining which alerts require immediate investigation. Incident use cases help analysts recognize and respond to common attack patterns."
  },
  {
    "id": 204,
    "topic_id": 200,
    "title": "What are the primary characteristics and motivations of different types of threat actors?",
    "description": "Threat actors vary in their intent, motivations, capabilities, and resources. Nation-state actors conduct espionage and sabotage with sophisticated resources. Organized cybercriminals seek financial gain. Hacktivists pursue political or social agendas. Insider threats exploit legitimate access. Script kiddies use publicly available tools with limited sophistication."
  },
  {
    "id": 205,
    "topic_id": 200,
    "title": "What is cyber threat intelligence and what sources do organizations use to obtain it?",
    "description": "Cyber threat intelligence (CTI) involves collecting and analyzing information about threats, threat actors, and their tactics, techniques, and procedures (TTPs). Indicators of compromise (IoCs) are forensic artifacts that suggest a system has been breached. Organizations obtain CTI from open sources, commercial vendors, government agencies, and industry ISACs."
  },
  {
    "id": 206,
    "topic_id": 200,
    "title": "What are the four key elements analyzed in the Diamond Model of cyber attacks?",
    "description": "Threat frameworks provide structured approaches for analyzing attacks. The MITRE ATT&CK framework catalogs adversary tactics and techniques. The Cyber Kill Chain models attacks as seven sequential stages. The Diamond Model analyzes attacks through four elements: the adversary, the capability, the infrastructure, and the victim."
  },
  {
    "id": 207,
    "topic_id": 200,
    "title": "What are the four phases of the incident response process?",
    "description": "The four phases of the incident response process are preparation, detection & analysis, containment, eradication & recovery, and post-incident activity."
  },
  {
    "id": 208,
    "topic_id": 200,
    "title": "What departments and roles should be represented on an incident response team?",
    "description": "Incident response teams commonly include members from management, information security, physical security, legal counsel, public relations, and human resources, along with technical subject matter experts."
  },
  {
    "id": 209,
    "topic_id": 200,
    "title": "What is the highest technical priority for a first responder during incident response?",
    "description": "The highest technical priority of a first responder during incident response is to quickly contain the damage caused by the security incident."
  },
  {
    "id": 210,
    "topic_id": 200,
    "title": "What role do SIEM systems play in managing security logs and events across an organization?",
    "description": "Security information and event management (SIEM) systems act as centralized log repository and analysis solutions."
  },
  {
    "id": 211,
    "topic_id": 200,
    "title": "What are the stages that assets progress through during their lifecycle?",
    "description": "Assets progress through stages, including planning and procurement, deployment and configuration, operation and maintenance, monitoring and assessment, end of life, and disposal."
  },
  {
    "id": 212,
    "topic_id": 200,
    "title": "What security risks and compliance issues arise from running end-of-life or end-of-support software and devices?",
    "description": "End-of-life (EOL) and end-of-support (EOS) software and devices no longer receive security patches. Running unsupported technology creates serious security risks and may violate compliance requirements."
  },
  {
    "id": 213,
    "topic_id": 200,
    "title": "What does configuration management establish and maintain, and what are its key components?",
    "description": "Configuration management establishes and maintains the settings of technology assets. Key components include baselines and patch management."
  },
  {
    "id": 214,
    "topic_id": 200,
    "title": "What does change management ensure regarding modifications to systems and infrastructure?",
    "description": "Change management ensures that modifications are properly requested, evaluated, approved, implemented, documented, and reversible through rollback plans."
  },
  {
    "id": 215,
    "topic_id": 200,
    "title": "What are red teams, blue teams, and purple teams in security exercises?",
    "description": "Red teams simulate attacks. Blue teams defend. Purple teams combine both in a collaborative exercise to improve detection and response capabilities."
  },
  {
    "id": 216,
    "topic_id": 200,
    "title": "What are the four main application security testing techniques and their primary purposes?",
    "description": "Vulnerability scanning identifies known vulnerabilities. Static analysis examines source code without running it. Dynamic analysis tests the running application. Threat modeling identifies potential threats at the design level."
  },
  {
    "id": 217,
    "topic_id": 200,
    "title": "What advantage do authenticated vulnerability scans provide compared to unauthenticated scans?",
    "description": "Vulnerability scanners probe systems for known weaknesses. Authenticated scans provide more thorough results than unauthenticated scans."
  },
  {
    "id": 218,
    "topic_id": 200,
    "title": "What are the key differences between phishing, tailgating, and impersonation as social engineering attacks?",
    "description": "Phishing uses deceptive messages. Tailgating involves following an authorized person through a secured entrance. Impersonation involves pretending to be an authorized person."
  },
  {
    "id": 219,
    "topic_id": 200,
    "title": "What security considerations and governance requirements does AI introduce across the CC domains?",
    "description": "AI introduces new security considerations across all five CC domains. Model poisoning threatens data integrity, ethical AI use requires transparency and fairness, and AI systems must be included in governance, risk, and compliance (GRC) programs. Organizations should treat AI tools with the same level of oversight as any other technology asset."
  },
  {
    "id": 220,
    "topic_id": 200,
    "title": "What key considerations must business continuity planning address regarding AI systems?",
    "description": "Business continuity planning must account for AI systems. This includes backing up model files and training data, planning for AI-driven incident detection, and monitoring for model drift, where an AI system’s performance gradually degrades over time."
  },
  {
    "id": 221,
    "topic_id": 200,
    "title": "How should automated service accounts and AI entities be managed regarding access and privileges?",
    "description": "AI entities require access controls just like human users. Automated service accounts should follow the principle of least privilege and be managed through a formal lifecycle. AI also enhances authentication through behavioral analysis and anomaly detection."
  },
  {
    "id": 222,
    "topic_id": 200,
    "title": "What network security measures and architectural approaches should be implemented specifically for AI systems?",
    "description": "Network security for AI includes segmentation, Zero Trust (ZT), and AI-powered monitoring. AI development environments should be isolated from production data, and AI-powered firewalls and intrusion detection systems can identify threats that traditional tools miss."
  },
  {
    "id": 223,
    "topic_id": 200,
    "title": "What measures should organizations implement regarding employee use of public AI services and large language models?",
    "description": "Security operations teams work alongside AI tools daily. SIEM platforms use AI to reduce alert fatigue, and organizations must establish policies to prevent data leakage when employees use public AI services and large language models."
  }
];
